var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 49,
    viewBox: "0 0 43 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 42.1344V25.8656L4.875 17.6125V33.8812L19.125 42.1344ZM23.875 42.1344L38.125 33.8812V17.6125L23.875 25.8656V42.1344ZM21.5 21.7687L35.5719 13.6344L21.5 5.5L7.42812 13.6344L21.5 21.7687ZM2.5 38.0375C1.74792 37.6021 1.16406 37.0281 0.748437 36.3156C0.332813 35.6031 0.125 34.8115 0.125 33.9406V15.0594C0.125 14.1885 0.332813 13.3969 0.748437 12.6844C1.16406 11.9719 1.74792 11.3979 2.5 10.9625L19.125 1.40312C19.8771 0.967708 20.6687 0.75 21.5 0.75C22.3312 0.75 23.1229 0.967708 23.875 1.40312L40.5 10.9625C41.2521 11.3979 41.8359 11.9719 42.2516 12.6844C42.6672 13.3969 42.875 14.1885 42.875 15.0594V33.9406C42.875 34.8115 42.6672 35.6031 42.2516 36.3156C41.8359 37.0281 41.2521 37.6021 40.5 38.0375L23.875 47.5969C23.1229 48.0323 22.3312 48.25 21.5 48.25C20.6687 48.25 19.8771 48.0323 19.125 47.5969L2.5 38.0375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.7c784aca823a1e176a6eb845108fdc32.svg";
export { ForwardRef as ReactComponent };